<section class="header">
  <h2>{{company.name}} is a software development company based in Michigan.</h2>
</section>

<section class="projects">
  <ng-container *ngIf="projects$ | async as _projects; else loadingOrError">
    <anon-masonry-grid [items]="_projects"></anon-masonry-grid>
    <em *ngIf="!_projects.length">No portfolio projects yet, check back soon!</em>
  </ng-container>
  <ng-template #loadingOrError>
    <anon-loading-or-error [error]="error"></anon-loading-or-error>
  </ng-template>
</section>

<mat-divider></mat-divider>

<section class="learn-more">
  <h2>Want to learn more?</h2>
  <h3>Reach out to learn more about us and our projects.</h3>
</section>
